/* tslint:disable */
/* eslint-disable */
/**
 * BackendFramework
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { Flag } from "./flag";
import { Note } from "./note";
import { Pronunciation } from "./pronunciation";
import { ProtectReason } from "./protect-reason";
import { Sense } from "./sense";
import { Status } from "./status";

/**
 *
 * @export
 * @interface Word
 */
export interface Word {
  /**
   *
   * @type {string}
   * @memberof Word
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof Word
   */
  guid: string;
  /**
   *
   * @type {string}
   * @memberof Word
   */
  vernacular: string;
  /**
   *
   * @type {boolean}
   * @memberof Word
   */
  usingCitationForm?: boolean;
  /**
   *
   * @type {string}
   * @memberof Word
   */
  plural?: string | null;
  /**
   *
   * @type {Array<Sense>}
   * @memberof Word
   */
  senses: Array<Sense>;
  /**
   *
   * @type {Array<Pronunciation>}
   * @memberof Word
   */
  audio: Array<Pronunciation>;
  /**
   *
   * @type {string}
   * @memberof Word
   */
  created: string;
  /**
   *
   * @type {string}
   * @memberof Word
   */
  modified: string;
  /**
   *
   * @type {Status}
   * @memberof Word
   */
  accessibility: Status;
  /**
   *
   * @type {Array<ProtectReason>}
   * @memberof Word
   */
  protectReasons?: Array<ProtectReason> | null;
  /**
   *
   * @type {Array<string>}
   * @memberof Word
   */
  history: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof Word
   */
  editedBy?: Array<string> | null;
  /**
   *
   * @type {string}
   * @memberof Word
   */
  otherField?: string | null;
  /**
   *
   * @type {string}
   * @memberof Word
   */
  projectId: string;
  /**
   *
   * @type {Note}
   * @memberof Word
   */
  note: Note;
  /**
   *
   * @type {Flag}
   * @memberof Word
   */
  flag: Flag;
}
